import helper from "./helper";
import cash from "cash-dom";
import Toastify from "toastify-js";

(function () {
    "use strict";
    if (cash('#print-new-label').length) {
        cash('#print-new-label').each((index, ele) => {
            ele.addEventListener('click', () => {
                helper.postAjax('printjob/add', {
                    id: ele.dataset.id
                }, function (response) {
                    if (response == 200) {
                        Toastify({
                            node: $("#success-notification-content").clone().removeClass("hidden")[0],
                            duration: 3000,
                            newWindow: true,
                            close: true,
                            gravity: "top",
                            position: "right",
                            stopOnFocus: true,
                        }).showToast();
                        tailwind.Modal.getInstance(document.querySelector("#modal-new-label")).hide();
                    }
                })
            })
        })
    }
    if (cash('.__change-status').length) {
        cash('.__change-status').each((index, ele) => {
            ele.addEventListener('click', () => {
                helper.postAjax(`/inv/item/${ele.dataset.id}/status/`, {
                    status: ele.dataset.status,
                    note: cash('#id_status_note').first().val()
                }, function (response) {
                    if (response == 200) {
                        location.reload();
                    }
                })
            })
        })
    }
})();
